
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PensionModalContact } from './components/PensionModalContact';
import { PensionSectionAbout } from './components/PensionSectionAbout';
import { PensionSectionActions } from './components/PensionSectionActions';
import { PensionSectionBenefits } from './components/PensionSectionBenefits';
import { PensionSectionFAQ } from './components/PensionSectionFAQ';
import { PensionSectionFooter } from './components/PensionSectionFooter';
import { PensionSectionHero } from './components/PensionSectionHero';
import { PensionSectionHowTo } from './components/PensionSectionHowTo';
import { PensionSectionSimulator } from './components/PensionSectionSimulator';
import { Notification } from '@/modules/common/components/Notification';
import { PageTitle } from '@/modules/common/helpers/title';
import {
  PensionLandingModule,
  ActionFetchAuthUser
} from '@/modules/pension/store/pension-landing';

const PensionModule = namespace('PensionLandingModule');

@Component({
  components: {
    PensionModalContact,
    PensionSectionAbout,
    PensionSectionActions,
    PensionSectionBenefits,
    PensionSectionFAQ,
    PensionSectionFooter,
    PensionSectionHero,
    PensionSectionHowTo,
    PensionSectionSimulator,
    Notification,
    PensionLandingModule
  }
})
export default class PensionView extends Vue {
  @PageTitle()
  private title = 'Previdência';

  @PensionModule.Action('fetchAuthUser')
  private fetchAuthUser!: ActionFetchAuthUser;

  private created() {
    this.fetchAuthUser();
  }
}
